import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileDetails: {},
};
const profileDetailsSlice = createSlice({
  name: "profileDetails",
  initialState,
  reducers: {
    updateProfileDetails: (state, action) => {
      state.profileDetails = action.payload.profileDetails;
    },
  },
});

export const { updateProfileDetails } = profileDetailsSlice.actions;
export default profileDetailsSlice;
